import React from "react";
import { DropDown } from "@src/components/atoms";
import SignolUtils from "@src/utils/signolUtils.js";
import AppUtils from "@src/utils/appUtils.js";
import { useDCContext } from "@src/context/dcContext";
import VehicleFilter from "./VehicleFilter";

const AdditionalFiltersMenu = (props) => {
  const { vehicleTypes, routes, additionalFilters, updateFilters, isAviation } =
    props;
  const dcContext = useDCContext();
  const { getDynamicReplacement } = dcContext;
  const destinations = SignolUtils.filterArrayUnique(
    routes.map((route) => route.destination),
  );
  const origins = SignolUtils.filterArrayUnique(
    routes.map((route) => route.origin),
  );

  //dynamic content
  const behaviourFilterTitle = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__behaviour_filter__menu_title",
  );
  const behaviourFilterAllOption = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__behaviour_filter__all_option",
    {},
    "All",
    true,
  );
  const behaviourFilterSuccessOption = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__behaviour_filter__success_option",
    {},
    "Successful",
    true,
  );
  const behaviourFilterFailOption = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__behaviour_filter__fail_option",
    {},
    "Unsuccessful",
    true,
  );
  const originFilterTitle = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__origin_filter__menu_title",
  );
  const originFilterAllOption = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__origin_filter__all_option",
    {},
    "All",
    true,
  );
  const destinationFilterTitle = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__destination_filter__menu_title",
  );
  const destinationFilterAllOption = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__destination_filter__all_option",
    {},
    "All",
    true,
  );

  const destinationOptions = [
    {
      text: destinationFilterAllOption,
      value: "ALL",
    },
  ];
  const originOptions = [
    {
      text: originFilterAllOption,
      value: "ALL",
    },
  ];

  if (additionalFilters.origin.value !== "ALL") {
    const applicableDestinations = SignolUtils.filterArrayUnique(
      routes
        .filter((route) => route.origin === additionalFilters.origin.value)
        .map((route) => route.destination),
    );
    applicableDestinations.forEach((destination) => {
      destinationOptions.push({
        value: destination,
        text: destination,
      });
    });
  } else {
    destinations.forEach((destination) => {
      destinationOptions.push({
        value: destination,
        text: destination,
      });
    });
  }

  if (additionalFilters.destination.value !== "ALL") {
    const applicableOrigins = SignolUtils.filterArrayUnique(
      routes
        .filter(
          (route) => route.destination === additionalFilters.destination.value,
        )
        .map((route) => route.origin),
    );
    applicableOrigins.forEach((origin) => {
      originOptions.push({
        value: origin,
        text: origin,
      });
    });
  } else {
    origins.forEach((origin) => {
      originOptions.push({
        value: origin,
        text: origin,
      });
    });
  }

  const successOptions = [
    {
      text: behaviourFilterAllOption,
      value: "ALL",
    },
    {
      text: behaviourFilterSuccessOption,
      value: "SUCCESS",
    },
    {
      text: behaviourFilterFailOption,
      value: "FAIL",
    },
  ];

  const updateSuccessValue = (e) => {
    const newAdditionalFilters = { ...additionalFilters };
    newAdditionalFilters["success"].value = e;
    updateFilters("additionalFilters", newAdditionalFilters);
  };

  const updateOriginValue = (e) => {
    const newAdditionalFilters = { ...additionalFilters };
    newAdditionalFilters["origin"].value = e;
    updateFilters("additionalFilters", newAdditionalFilters);
  };

  const updateDestinationValue = (e) => {
    const newAdditionalFilters = { ...additionalFilters };
    newAdditionalFilters["destination"].value = e;
    updateFilters("additionalFilters", newAdditionalFilters);
  };

  const updateVehicleValue = (e) => {
    const newAdditionalFilters = { ...additionalFilters };
    newAdditionalFilters["vehicle"] = e;
    updateFilters("additionalFilters", newAdditionalFilters);
  };

  return (
    <div className="py-5 px-7 flex flex-col">
      <div className="mb-3">
        <div className="font-bold mb-1">{behaviourFilterTitle}</div>
        <DropDown
          minWidth={false}
          options={successOptions}
          value={additionalFilters["success"].value}
          onChange={updateSuccessValue}
        />
      </div>
      <div className="mb-3">
        <VehicleFilter
          isAviation={isAviation}
          vehicleTypes={vehicleTypes}
          vehicleFilter={additionalFilters["vehicle"]}
          onChange={updateVehicleValue}
        />
      </div>
      <div className={`flex ${isAviation ? "flex-col" : "items-center"}`}>
        <div className="grow">
          <div className="font-bold mb-1">{originFilterTitle}</div>
          <div className={isAviation ? "mb-3" : ""}>
            <DropDown
              minWidth={false}
              options={originOptions}
              value={additionalFilters["origin"].value}
              onChange={updateOriginValue}
            />
          </div>
        </div>
        {!isAviation && <div className="mt-8 px-2 text-silver-300">-</div>}
        <div className="grow">
          <div className="font-bold mb-1">{destinationFilterTitle}</div>
          <DropDown
            minWidth={false}
            options={destinationOptions}
            value={additionalFilters["destination"].value}
            onChange={updateDestinationValue}
          />
        </div>
      </div>
    </div>
  );
};

export const AdditionalFiltersMenuControls = {};
AdditionalFiltersMenu.propTypes = AppUtils.getPropTypeFromControls(
  AdditionalFiltersMenuControls,
);

export default AdditionalFiltersMenu;
